// Alpine
import './alpine.js';

// Navigation
import { defochtelNavigation } from './navigation';
import { defochtelLightgallery } from './lightgallery.js';
import { defochtelContentBlock, defochtelSwiper } from './swiper.js';
import { defochtelParallaxHomepageHeader, defochtelParallaxSectionHeader } from './parallax.js';

document.addEventListener(
	'DOMContentLoaded',
	() => {
		// Navigation
		defochtelNavigation();

		// Lightgallery
		defochtelLightgallery();

		// Swiper
		defochtelSwiper();
		defochtelContentBlock();

		// Parallax
		defochtelParallaxSectionHeader();
		defochtelParallaxHomepageHeader();
	},
	{ passive: true }
);
